import styled from '@emotion/styled'

import type { FC } from 'react'

import SearchBar from '@segment/matcha/components/SearchBar'
import type { SearchBarProps } from '@segment/matcha/components/SearchBar/SearchBar'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

const copy = {
  heading: `Resources`,
  description: `Books, guides, and videos to help you on your customer data journey`,
}

interface HeroProps {
  query: SearchBarProps[`value`]
  onQueryChange: (newQuery: NonNullable<SearchBarProps[`value`]>) => void
  isQueryLoading: SearchBarProps[`isLoading`]
}

const Hero: FC<HeroProps> = ({ query, onQueryChange, isQueryLoading }) => {
  return (
    <Wrapper>
      <StyledHeroRecipeBase variant="centered" copyVariant="wide">
        <HeroRecipe.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h1" variant="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="h2">{copy.description}</CopyText.Description>
          </CopyTextBase>
        </HeroRecipe.Copy>
        <StyledHeroContents>
          <SearchBar
            aria-label="Search resources"
            name="recipes"
            placeholder="Search resources…"
            value={query}
            onChange={(_e, value) => onQueryChange(value ?? ``)}
            onClear={() => onQueryChange(``)}
            isLoading={isQueryLoading}
          />
        </StyledHeroContents>
      </StyledHeroRecipeBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHeroRecipeBase = styled(HeroRecipeBase)`
  ${HeroRecipe.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`sm`)} {
    }
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-bottom: 80px;
    }
  }
`

const StyledHeroContents = styled(HeroRecipe.Contents)`
  max-width: 520px;
`

export default Hero
